/* tslint:disable */

declare var Object: any;
export interface ViewOndutyPurposeItemInterface {
  "companyId": number;
  "purposeCode": string;
  "itemCode": string;
  "categoryCode"?: string;
  "type"?: string;
  "itemNameEn"?: string;
  "itemNameId"?: string;
  "formula"?: string;
  "currencyCode"?: string;
}

export class ViewOndutyPurposeItem implements ViewOndutyPurposeItemInterface {
  "companyId": number;
  "purposeCode": string;
  "itemCode": string;
  "categoryCode": string;
  "type": string;
  "itemNameEn": string;
  "itemNameId": string;
  "formula": string;
  "currencyCode": string;
  constructor(data?: ViewOndutyPurposeItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewOndutyPurposeItem`.
   */
  public static getModelName() {
    return "ViewOndutyPurposeItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewOndutyPurposeItem for dynamic purposes.
  **/
  public static factory(data: ViewOndutyPurposeItemInterface): ViewOndutyPurposeItem{
    return new ViewOndutyPurposeItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewOndutyPurposeItem',
      plural: 'ViewOndutyPurposeItems',
      path: 'ViewOndutyPurposeItems',
      properties: {
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "purposeCode": {
          name: 'purposeCode',
          type: 'string'
        },
        "itemCode": {
          name: 'itemCode',
          type: 'string'
        },
        "categoryCode": {
          name: 'categoryCode',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "itemNameEn": {
          name: 'itemNameEn',
          type: 'string'
        },
        "itemNameId": {
          name: 'itemNameId',
          type: 'string'
        },
        "formula": {
          name: 'formula',
          type: 'string'
        },
        "currencyCode": {
          name: 'currencyCode',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewOndutyPurposeItem.ts